import { ethers } from "ethers";
import { getPalette as computePalette } from "bitframes";
import dateformat from "dateformat";
import { writable } from "svelte/store";
// export const DEFAULT_BACKGROUND = getPalette()[0];

const CONTRACTS_SEPOLIA = {
  CROWDFUND: {
    address: "0xc4f5d298B26Dc8f4E78Ecf7BdC043644A104A0B9",
    fromBlock: 7036520,
    previousVersions: [
      {
        address: "0x3d18Ed8b3Bf4be0fbba968E2D33581024c318EC7",
        fromBlock: 6844155,
      },
    ],
  },
  NFT_OPEN: {
    type: "open",
    id: "67176f8edd07536d64dc9e02",
    address: "0x156859c6b4de234aA961cCAf4840e5E2089a351e",
    mechanicVectorId:
      "0xec5c8f5db72bf67568214dedd50ddbd1a3472b472d9e86ccf24ffdff20b0ecb3",
    fromBlock: 6921873,
  },
  NFT_LIMITED: {
    type: "limited",
    id: "6720f8b835cec8c03bf0a308",
    address: "0xd953C71B4E8525FCf0eC0E78214bbBDC58E43B77",
    mechanicVectorId:
      "0xb96dabe02c834a958a4dc2004948dd3da1fca125663a29ab04b7e77cecd33a58",
    fromBlock: 6970559,
  },
};

const CONTRACTS_MAINNET = {
  CROWDFUND: {
    address: "0x642fEd40AeD8e7A7CF7c4CFf77F2529a4348ccC3",
    fromBlock: 21215952,
  },
  NFT_OPEN: {
    type: "open",
    id: "673b4d388cec5b07a4b6d4bf",
    address: "0x2c7f335460fB9dF460FF7AD6CC64cb7Dd4064862",
    mechanicVectorId:
      "0x15a6cd191610404c0d149688accc6b481cd673b8b00e75ad00511e082f279e1b",
    fromBlock: 21215165,
  },
  NFT_LIMITED: {
    type: "limited",
    id: "673b4dfa884babe951adfc82",
    address: "0xd4621fc799B88605A4a00B0D2A3415aba9EAc5Dc",
    mechanicVectorId:
      "0x6608408c1eb5727ec0af52329893a0f0ce1036a762df6b10e07dd3283ee80308",
    fromBlock: 21215183,
  },
};

export const API_IS_LOCAL = false;

let defaultNetwork = "mainnet";
const params = new URLSearchParams(window.location.search);
if (params.has("sepolia") || params.has("testnet")) {
  defaultNetwork = "sepolia";
}
if (params.has("mainnet")) {
  defaultNetwork = "mainnet";
}

export const CONTRACT_NETWORK = defaultNetwork;
export const CONTRACTS =
  CONTRACT_NETWORK === "sepolia" ? CONTRACTS_SEPOLIA : CONTRACTS_MAINNET;

export const IS_PRE_LAUNCH = false;

export const API_BASE_URL = API_IS_LOCAL
  ? "http://localhost:8787"
  : `https://prj-bitframes-${CONTRACT_NETWORK === "sepolia" ? "sepolia-" : ""}server.twilight-shape-28f0.workers.dev`;

export const ENS_API_BASE_URL = API_IS_LOCAL
  ? "http://localhost:8787"
  : `https://prj-bitframes-${CONTRACT_NETWORK === "sepolia" ? "sepolia-" : ""}ens-server.twilight-shape-28f0.workers.dev`;

export const PLATFORM_FEE_ETH = 0.0;
export const OPEN_COLLECTION_ID = CONTRACTS.NFT_OPEN.id;
export const CONTRACT_ADDRESS = CONTRACTS.NFT_OPEN.address;
export const DEFAULT_CONTRACT_ADDRESS = CONTRACTS.NFT_OPEN.address;

export const ETHERSCAN_BASE_URL =
  CONTRACT_NETWORK === "mainnet"
    ? `https://etherscan.io/`
    : `https://${CONTRACT_NETWORK}.etherscan.io/`;

export const CONTRACT_ETHERSCAN_URL = `${ETHERSCAN_BASE_URL}address/${CONTRACT_ADDRESS}`;
export const ETH_PRICE = 0.01;
export const MIN_ETH_PRICE_WITH_FEE_STRING = displayEther(
  ETH_PRICE,
  PLATFORM_FEE_ETH
);

export const SALE_START_DATE = new Date("2024-11-22T17:00:00Z");

export const SALE_END_DATE = new Date("2024-12-20T17:00:00Z");

// export const SALE_START_DATE = new Date().toUTCString();
// export const SALE_END_DATE = new Date().toUTCString();

let allowTestnetMint = false;
if (params.has("testnet")) {
  allowTestnetMint = true;
}

const currentTime = new Date();
// export const IS_BEFORE_LAUNCH = currentTime <= SALE_START_DATE;
export const isBeforeLaunchStore = writable(false);
// const launchStateTick = setInterval(() => {
//   isBeforeLaunchStore.update(() =>
//     allowTestnetMint ? false : new Date() < SALE_START_DATE
//   );
// }, 1000);

export const isAfterLaunchStore = writable(currentTime > SALE_END_DATE);
const afterLaunchStateTick = setInterval(() => {
  isAfterLaunchStore.update(() => new Date() > SALE_END_DATE);
}, 1000);

// Time constants
const MS_IN_SECOND = 1000;
const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

// Helper function to calculate time breakdown
function getTimeBreakdown(ms) {
  const days = Math.floor(
    ms / (MS_IN_SECOND * SECONDS_IN_MINUTE * MINUTES_IN_HOUR * HOURS_IN_DAY)
  );
  const hours = Math.floor(
    (ms % (MS_IN_SECOND * SECONDS_IN_MINUTE * MINUTES_IN_HOUR * HOURS_IN_DAY)) /
      (MS_IN_SECOND * SECONDS_IN_MINUTE * MINUTES_IN_HOUR)
  );
  const minutes = Math.floor(
    (ms % (MS_IN_SECOND * SECONDS_IN_MINUTE * MINUTES_IN_HOUR)) /
      (MS_IN_SECOND * SECONDS_IN_MINUTE)
  );
  const seconds = Math.floor(
    (ms % (MS_IN_SECOND * SECONDS_IN_MINUTE)) / MS_IN_SECOND
  );
  return { days, hours, minutes, seconds };
}

export function getCountdownText() {
  const now = new Date();
  const timeDifference = SALE_START_DATE - now;
  if (timeDifference <= 0) {
    return null;
  }
  const { days, hours, minutes, seconds } = getTimeBreakdown(timeDifference);
  const hr = "hours";
  const min = "min";
  const sec = "sec";
  const dayStr = "days";
  const parts = [
    [days, dayStr],
    [hours, hr],
    [minutes, min],
    [seconds, sec],
  ];
  let textParts = [];
  // let hasStarted = false;
  for (let i = 0; i < parts.length; i++) {
    const [amt, label] = parts[i];
    if (amt <= 0) continue;
    // if (amt <= 0) continue;
    // hasStarted = true;
    textParts.push([amt, label].join(" "));
  }
  return textParts.join(", ");
}

export const SALE_START_DATE_FMT = formatAuctionTime(SALE_START_DATE);
export const SALE_START_DATE_FMT_GMT = formatAuctionTime(SALE_START_DATE, true);
export const SALE_END_DATE_FMT = formatAuctionTime(SALE_END_DATE);
export const SALE_END_DATE_FMT_GMT = formatAuctionTime(SALE_END_DATE, true);

export const GENERATIVE_FILM_URL = "https://generativefilm.io/";
export const GITHUB_CODE_URL = "https://github.com/mattdesl/bitframes";
export const GITHUB_RAFFLE_SPEC_URL =
  "https://github.com/mattdesl/bitframes-randao";
export const ENDAOMENT_URL =
  "https://app.endaoment.org/orgs/32-0295081/0cb4c73d-4b9f-4817-8b1d-0c7054b5fcf4";
export const HIGHLIGHT_URL = "https://highlight.xyz";

export const LINK_HOME = "";
export const LINK_CREATE = "create";
export const LINK_CREATE_EDITION = "refresh";
export const LINK_GALLERY = "gallery";
export const LINK_EDITIONS = "editions";
export const LINK_ABOUT = "about";
export const LINK_TERMS = "terms";
export const LINK_DONATE = "donate";
export const LINK_EPISODES = "episodes";

export const PATH_HOME = `/${LINK_HOME}`;
export const PATH_CREATE = `/${LINK_CREATE}`;
export const PATH_CREATE_EDITION = `/${LINK_CREATE_EDITION}`;
export const PATH_GALLERY = `/${LINK_GALLERY}`;
export const PATH_EDITIONS = `/${LINK_EDITIONS}`;
export const PATH_ABOUT = `/${LINK_ABOUT}`;
export const PATH_TERMS = `/${LINK_TERMS}`;
export const PATH_DONATE = `/${LINK_DONATE}`;

export const ASSET_BASE_URL = "https://r2.bitframes.io/assets/";
// export const ASSET_BASE_URL = "/";
// export const ASSET_BASE_URL =
//   "https://pub-ceba2e7837b54f47bd2acb7034e81032.r2.dev/assets/";

const supportsP3 =
  typeof window.CSS !== "undefined" &&
  window.CSS.supports("color", "color(display-p3 0 1 0)");

const canUseP3InCanvas = (() => {
  const canvas = document.createElement("canvas");
  canvas.width = canvas.height = 1;
  const ctx = canvas.getContext("2d", { colorSpace: "display-p3" });
  const attr = ctx.getContextAttributes && ctx.getContextAttributes();
  return attr && attr.colorSpace === "display-p3";
})();

export const colorSpace =
  canUseP3InCanvas && supportsP3 ? "display-p3" : "srgb";

export const PALETTE_0x00 = computePalette({ colorSpace, system: 0x00 });
export const PALETTE_0x01 = computePalette({ colorSpace, system: 0x01 });

export function getPalette(opts = {}) {
  const { system = 0x00 } = opts;
  return system === 0x00 ? PALETTE_0x00 : PALETTE_0x01;
}

export const INTERVIEWS = [
  {
    id: "grant",
    duration: 2643.96,
    src: `${ASSET_BASE_URL}audio/grant`,
    episode: 1,
    speakers: "Matt DesLauriers and Grant D. Taylor",
    title: "COMPUTER ART IN THE MAINFRAME ERA",
    background: `${ASSET_BASE_URL}images/mainframe.jpg`,
    about:
      "A conversation with Grant D. Taylor, professor of art and art history at Lebanon Valley College, Pennsylvania, with an expertise in computer art.",
  },
  {
    id: "melanie",
    duration: 1810.8342857142857,
    src: `${ASSET_BASE_URL}audio/melanie`,
    episode: 2,
    background: `${ASSET_BASE_URL}images/punch.jpg`,
    speakers: "Matt DesLauriers and Melanie Lenz",
    title: "A CONVERSATION ABOUT BITFRAMES",
    about: `An interview with Melanie Lenz, independent curator and curator of Digital Art at the Victoria & Albert Museum in London, UK.`,
  },
];

export function getBackground(opts = {}) {
  const { system = 0 } = opts;
  return (system == 0x00 ? PALETTE_0x00 : PALETTE_0x01)[0];
}

export function createEtherscanLink(opts = {}) {
  const { network = CONTRACT_NETWORK, type = "tx", fragment = "" } = opts;
  const subdomain = network === "mainnet" ? "" : `${network.toLowerCase()}.`;
  return `https://${subdomain}etherscan.io/${type}/${fragment}`;
}

// weekly block ranges for mainnet
export const WEEKLY_BLOCK_RANGE = [
  21244596, 21294592, 21344588, 21394584, 21444580,
];

export function getBlockWeek(blockNumber) {
  for (let i = WEEKLY_BLOCK_RANGE.length - 1; i >= 0; i--) {
    if (blockNumber >= WEEKLY_BLOCK_RANGE[i]) {
      return Math.min(4, i + 1);
    }
  }
  return 1; // initial week
}

export function displayEther(price, fee) {
  const num0 = ethers.parseEther(String(price));
  const num1 = ethers.parseEther(String(fee));
  const sum = num0 + num1;
  return ethers.formatEther(sum);
}

export function formatAuctionTime(date, timezone) {
  return dateformat(date, "GMT:mmm dd, yyyy h:MM TT" + (timezone ? " Z" : ""));
}

export function formatEther(val) {
  try {
    return ethers.formatEther(val);
  } catch (err) {
    console.warn(err);
    return "--";
  }
}
